// Lib
import React from 'react';
import { useStyles } from './AddressTitleStyles';

const AddressTitle = ({ title, className, ...props }) => {
  const { classes, cx } = useStyles();
  return (
    <div className={cx(classes.title, className)} {...props}>
      {title}
    </div>
  );
};

export default AddressTitle;
